/**
 * HoneyPop launcher trigger
 * ─────────────────────────
 * Add  data-open-honeypop  to any <a> or <button> in the theme editor
 * and clicking it will open the HoneyPop / loyalty modal.
 *
 * Example button label usage: just add the attribute in the button's HTML
 * or use the hero button link field with "#honeypop" and the script below
 * also intercepts href="#honeypop".
 */
(function () {
  function openHoneyPop() {
    // Try the fixed launcher button HoneyPop injects into the page
    const launcher =
      document.querySelector('button[class*="_BubbleLauncher_"]') ||
      document.querySelector('#honeypop-app button') ||
      document.querySelector('[id^="honeypop"] button');

    if (launcher) {
      launcher.click();
      return true;
    }
    return false;
  }

  function handleTriggerClick(e) {
    e.preventDefault();
    // Small retry loop in case the app hasn't fully rendered yet
    if (!openHoneyPop()) {
      let attempts = 0;
      const interval = setInterval(function () {
        if (openHoneyPop() || ++attempts >= 10) clearInterval(interval);
      }, 200);
    }
  }

  function bindTriggers() {
    // Match: data-open-honeypop attribute OR href="#honeypop"
    document.querySelectorAll(
      '[data-open-honeypop], a[href="#honeypop"]'
    ).forEach(function (el) {
      el.removeEventListener('click', handleTriggerClick);
      el.addEventListener('click', handleTriggerClick);
    });
  }

  // Bind on load and after any Shopify section re-renders (theme editor)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers);
  } else {
    bindTriggers();
  }

  // Re-bind when theme editor re-renders a section
  document.addEventListener('shopify:section:load', bindTriggers);
})();